import { ModelBase, Property, Range, Required, ShortString } from '@skylab-shared/core';

export class OssVatRateModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property(String, { nullable: true })
    public externalId: string | null;

    @Property()
    public default: boolean;

    @Property()
    public active: boolean;

    @Property()
    @ShortString('data-model.oss-vat-rate.validation.name.length')
    @Required('data-model.oss-vat-rate.validation.name.non-empty')
    public name: string;

    @Property()
    @ShortString('data-model.oss-vat-rate.validation.symbol.length')
    @Required('data-model.oss-vat-rate.validation.symbol.non-empty')
    public symbol: string;

    @Property()
    public countryId: number;

    @Property()
    @Range({ min: 0, max: 1 }, 'data-model.oss-vat-rate.validation.rate.range')
    public rate: number;

    @Property()
    public inUse: boolean;
}
